<template lang="pug">
  b-form-group(label-cols="2" :label="label" label-align="left" :label-for="id_custom" :description="description")
    b-input-group()
      b-container(fluid)
        b-row(fluid)
          b-col(cols = 12)
            b-input-group(prepend="Range" :append="sufix")
              b-form-input(:id="id_custom" :name="id_custom" :type='type' v-model="spec.input")
              b-form-input(:id="id_custom" :name="id_custom" :type='type' v-model="spec.output")
          //b-col(md = 3, cols = 12)
            div
              b-input-group(append="%")
                b-form-input(:id="id_custom" :name="id_custom" :type='type' )
</template>

<script>
  export default {
    name: "InputInOut",
    props: ['label','id_custom','type','description','sufix','value'],
    data(){
      return{
        spec: {
          input: "",
          output: "",
          percentage: "",
        }
      }
    },
    mounted() {
      this.spec = this.value;
    },
    watch: {
      spec: function (newSpec, oldSpec){
        this.$emit('input', newSpec);
      }
    }
  }
</script>

<style scoped>

</style>